/**
 * Cyclic Honor Hall season names (config/honorHallSeasons.json) — localized via i18n.
 */

const CYCLIC_SEASON_COUNT = 12;

/**
 * @param {import('i18next').TFunction} t
 * @param {number|string} cyclicSeasonNumber 1–12
 * @returns {string}
 */
export function getLocalizedSeasonName(t, cyclicSeasonNumber) {
  const n = Number(cyclicSeasonNumber);
  if (!Number.isInteger(n) || n < 1 || n > CYCLIC_SEASON_COUNT) {
    throw new Error(
      `getLocalizedSeasonName: cyclicSeasonNumber must be 1–${CYCLIC_SEASON_COUNT}, got ${String(cyclicSeasonNumber)}`
    );
  }
  const key = `honorHallSeasons.names.${n}`;
  const localized = t(key);
  if (localized === key) {
    throw new Error(`getLocalizedSeasonName: missing translation for ${key}`);
  }
  return localized;
}
